import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { SettingType } from 'helpers/setting-type-enum'
import { AccountType } from 'helpers/account-type-enum'

import client from 'api'

const initialState = {
    getStatus: 'idle',
    settings: {
        forceMainFilterType: {},
        mainFilterType: {
            [AccountType.PersonAccount]: 0,
            [AccountType.LedgerAccount]: 0,
            [AccountType.SupplierAccount]: 0,
            [AccountType.ProjectAccount]: 0,
            [AccountType.CostCenterAccount]: 0,
            [AccountType.AnlageAccount]: 0,
        },
        mainFilterTypeId: {
            [AccountType.PersonAccount]: null,
            [AccountType.LedgerAccount]: null,
            [AccountType.SupplierAccount]: null,
            [AccountType.ProjectAccount]: null,
            [AccountType.CostCenterAccount]: null,
            [AccountType.AnlageAccount]: null,
        },
        accountType: AccountType.LedgerAccount,

        accountTypeId: null,
    } as any
}


export const getSettings = createAsyncThunk('lookupSettings/getSettings', async () => {
    const res: any = await client.get('/api/ixweb/ixusersettings/')
    const data = {} as any
    res.data.forEach((setting: any) => {
        if (setting.SETTINGKEY === 'accountType') {
            data['accountType'] = Number(setting.SETTINGDATA_1)
            data['accountTypeId'] = setting.HDR_ID
        }
        if (setting.SETTINGKEY === 'mainFilterType') {
            data['mainFilterType'] = {...data['mainFilterType'], [`${setting.SETTINGNR}`]: Number(setting.SETTINGDATA_1)}
            data['mainFilterTypeId'] = {...data['mainFilterTypeId'], [`${setting.SETTINGNR}`]: setting.HDR_ID}
        }
    })
    return data
})

export const setSettingData = createAsyncThunk('lookupSettings/setSettingData', async (action: any, state: any) => {
    const { typeSetting, value, settingNumber } = action
    let data = {} as any
    const id = (typeSetting === 'mainFilterType')
        ? state.getState().accountLookupSlice.settings.mainFilterTypeId[`${settingNumber}`]
        : state.getState().accountLookupSlice.settings[`${typeSetting}Id`]

    data = (typeSetting === 'mainFilterType')
        ? {mainFilterType: {...state.getState().accountLookupSlice.settings.mainFilterType, [`${settingNumber}`]: value}}
        : {[typeSetting]: value}

    if (id) {
        client.put(`/api/ixweb/ixusersettings/${id}/`, {
            "SETTINGDATA_1": value
            })
    } else {
        await client.post('/api/ixweb/ixusersettings/', {
            "SETTINGDATA_1": value,
            "SETTINGKEY": 'account-lookup',
            "SETTINGTYPE": SettingType.ComponentSetting,
            'SETTINGNR': settingNumber || 1,
            'SETTINGNAME': typeSetting,
            'USERID': 5
        })
        .then((res: any) => typeSetting === 'mainFilterType' ? data['mainFilterTypeId'] = {...state.getState().accountLookupSlice.settings.mainFilterTypeId, [`${settingNumber}`]: res.data.HDR_ID} : data[`${typeSetting}Id`] = res.data.HDR_ID)
    }

    return data
})

const accountLookupSlice = createSlice({
    name: 'accountLookupSlice',
    initialState,
    reducers: {
        setSettings: (state, action) => {
            state.settings = {
                ...state.settings,
                ...action.payload
            }
        },
    },
    extraReducers: builder => {
        builder.addCase(getSettings.pending, (state) => {
            state.getStatus = 'pending'
        })
        builder.addCase(getSettings.fulfilled, (state, action) => {
            state.getStatus = 'fulfilled'
            state.settings = {
                ...state.settings,
                ...action.payload
            }
        })
        builder.addCase(setSettingData.fulfilled, (state, action) => {
            state.settings = {
                ...state.settings,
                ...action.payload
            }
        })
    }
})

export const { setSettings } = accountLookupSlice.actions

const setforceMainFilterTypeThunk = (value: any) => {
    return (dispatch: Function, getState: Function) => {
            const { forceMainFilterType } = getState().accountLookupSlice.settings
            dispatch(setSettings({forceMainFilterType: {...forceMainFilterType, ...value}}))
        }

}

const deleteforceMainFilterTypeThunk = (accountName: any) => {
    return (dispatch: Function, getState: Function) => {
            const { forceMainFilterType } = getState().accountLookupSlice.settings
            let filteredAccountNames: any = {}

            Object.keys(forceMainFilterType).filter((name: any) => (name !== accountName))
            .forEach((name: any) => {
                filteredAccountNames[name] = forceMainFilterType[name]
            })
            dispatch(setSettings({forceMainFilterType: {...filteredAccountNames}}))
        }
}

export { setforceMainFilterTypeThunk, deleteforceMainFilterTypeThunk }
export default accountLookupSlice.reducer
